import { render, staticRenderFns } from "./NeuroAcuteCareSummaryModal.vue?vue&type=template&id=d04a77bc&"
import script from "./NeuroAcuteCareSummaryModal.vue?vue&type=script&lang=ts&"
export * from "./NeuroAcuteCareSummaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d04a77bc')) {
      api.createRecord('d04a77bc', component.options)
    } else {
      api.reload('d04a77bc', component.options)
    }
    module.hot.accept("./NeuroAcuteCareSummaryModal.vue?vue&type=template&id=d04a77bc&", function () {
      api.rerender('d04a77bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/NeuroAcuteCareSummaryModal.vue"
export default component.exports